const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export function absUrl(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  return `${BACKEND}${url}`;
}

export function formatRupiah(value) {
  const n = Number(value || 0);
  return "Rp" + n.toLocaleString("id-ID");
}

export function hexToHsl(hex) {
  if (!hex) return null;
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const r = parseInt(h.substring(0, 2), 16) / 255;
  const g = parseInt(h.substring(2, 4), 16) / 255;
  const b = parseInt(h.substring(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let hue = 0;
  let sat = 0;
  const light = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    sat = light > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: hue = (g - b) / d + (g < b ? 6 : 0); break;
      case g: hue = (b - r) / d + 2; break;
      default: hue = (r - g) / d + 4;
    }
    hue /= 6;
  }
  return `${Math.round(hue * 360)} ${Math.round(sat * 100)}% ${Math.round(light * 100)}%`;
}

export function sanitizePhone(num) {
  return String(num || "").replace(/\D/g, "");
}

export function getPrimaryImage(product) {
  const imgs = product?.images || [];
  if (!imgs.length) return "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=600&q=80";
  const primary = imgs.find((i) => i.is_primary) || imgs[0];
  return absUrl(primary.url);
}

export function getThumbImage(product) {
  const imgs = product?.images || [];
  if (!imgs.length) return "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=200&q=70";
  const primary = imgs.find((i) => i.is_primary) || imgs[0];
  const url = primary.url || "";
  const thumb = url.endsWith(".webp") ? url.replace(/\.webp$/, "_thumb.webp") : url;
  return absUrl(thumb);
}

export const STOCK = {
  tersedia: { label: "Tersedia", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  terbatas: { label: "Stok Terbatas", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  habis: { label: "Habis", cls: "bg-rose-100 text-rose-700 border-rose-200" },
};

export function stockInfo(status) {
  return STOCK[status] || STOCK.tersedia;
}

export function buildWhatsAppText(template, ctx) {
  const map = {
    store_name: ctx.store_name,
    nama_produk: ctx.nama_produk,
    kategori: ctx.kategori,
    tipe_hp: ctx.tipe_hp,
    jumlah: ctx.jumlah,
    harga: ctx.harga,
    total: ctx.total,
    url_gambar: ctx.url_gambar,
    url_produk: ctx.url_produk,
    product_name: ctx.nama_produk,
    category_name: ctx.kategori,
    phone_model: ctx.tipe_hp,
    quantity: ctx.jumlah,
    product_price: ctx.harga,
  };
  let text = template || "";
  Object.entries(map).forEach(([k, v]) => {
    text = text.replaceAll(`{${k}}`, v == null ? "" : String(v));
  });
  return text;
}

export function buildWhatsAppUrl(number, text) {
  return `https://wa.me/${sanitizePhone(number)}?text=${encodeURIComponent(text)}`;
}

export function productUrl(slug) {
  return `${window.location.origin}/produk/${slug}`;
}
